import http from 'core/services/http';
import Config from 'core/config';

class OnlineTestingService {
  static getOnlineRegs(roomId, regTypeId = null) {
    const regTypeParam = regTypeId ? `?regTypeId=${regTypeId}` : '';
    return http.get(`${Config.apiUrl}/room/${roomId}/testNav/regStatus${regTypeParam}`);
  }

  static getIndividualOnlineReg(regId, includeProgressFlag) {
    const progressFlag = includeProgressFlag ? `?includeProgressFlag=${includeProgressFlag}` : '';
    return http.get(`${Config.apiUrl}/reg/${regId}/testNav/detail${progressFlag}`);
  }

  static getIndividualPsiOnlineReg(regId, forceRefresh) {
    const forceRefreshFlag = `?forceRefresh=${forceRefresh}`;
    return http.get(`${Config.apiUrl}/reg/${regId}/psi/detail${forceRefreshFlag}`);
  }

  static getSealCodes(roomId) {
    return http.get(`${Config.apiUrl}/query/testNavSealCodes?&roomId=${roomId}`);
  }

  static getAuthTickets(data) {
    return http.post(`${Config.apiUrl}/onlinereg/authTicketPdf/generate`, data);
  }

  static putLockedRegs(data) {
    return http.put(`${Config.apiUrl}/testNav/lock`, data);
  }

  static putStudentStatus(data) {
    return http.put(`${Config.apiUrl}/reg/testnav/status`, data);
  }

  static putPsiStudentStatus(status, data) {
    return http.put(`${Config.apiUrl}/reg/psi/${status}`, data);
  }

  static getOnlinePsiRegs(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/psi/regStatus`);
  }
  static unassignExaminees(roomId, list) {
    return http.put(`${Config.apiUrl}/room/${roomId}/unassignregs`, list);
  }
}

export default OnlineTestingService;
